import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getisAuthenticated, getParentSchools, getUserData } from '../modules/reducers';
import { setSchool, setParentSchools } from '../modules/actions';
import { FILE_DOWNLOAD_URL, BASEURL } from '../Config';

class SelectSchool extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: false };
    }

    componentDidMount() {
        if (this.props.parentSchools.length === 0) {
            const parentId = this.props.user && (this.props.user.parentId || this.props.user._id);
            if (!parentId) return;
            this.setState({ loading: true });
            axios.get(`${BASEURL}/api/v1/parent/getSchools/${parentId}`)
                .then(res => {
                    const schools = res.data || [];
                    this.props.setParentSchools(schools);
                    this.setState({ loading: false });
                })
                .catch(() => this.setState({ loading: false }));
        }
    }

    handleSelectSchool(school) {
        this.props.setSchool(school);
        const schoolPath = school.slug || school.name;
        window.location.href = 'school/' + schoolPath;
    }

    render() {
        const { parentSchools, isAuthenticated } = this.props;
        const { loading } = this.state;

        if (!isAuthenticated) {
            window.location.href = 'login';
            return null;
        }

        return (
            <div className="site-wrap">
                <Header />
                <div className="site-section">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-10">
                                <h2 className="h3 mb-2 text-black text-center">Select a School</h2>
                                <p className="text-muted text-center mb-5">
                                    Your account is linked to multiple schools. Please select one to continue.
                                </p>
                                {loading && (
                                    <div className="text-center py-4">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                )}
                                <div className="row">
                                    {!loading && parentSchools.length === 0 && (
                                        <div className="col-12 text-center text-muted">
                                            No schools found for your account.
                                        </div>
                                    )}
                                    {parentSchools.map((school, idx) => (
                                        <div className="col-md-4 mb-4" key={school._id || idx}>
                                            <div
                                                className="card h-100 text-center"
                                                style={{ cursor: 'pointer', transition: 'box-shadow 0.2s' }}
                                                onClick={() => this.handleSelectSchool(school)}
                                                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.15)'}
                                                onMouseLeave={e => e.currentTarget.style.boxShadow = ''}
                                            >
                                                <div className="card-body d-flex flex-column align-items-center justify-content-center p-4">
                                                    {school.thb ? (
                                                        <img
                                                            src={FILE_DOWNLOAD_URL + '/' + school.thb}
                                                            alt={school.name}
                                                            style={{ height: '70px', objectFit: 'contain', marginBottom: '16px' }}
                                                        />
                                                    ) : (
                                                        <div style={{ height: '70px', marginBottom: '16px', display: 'flex', alignItems: 'center' }}>
                                                            <span className="icon icon-home" style={{ fontSize: '40px', color: '#ccc' }} />
                                                        </div>
                                                    )}
                                                    <h5 className="card-title text-black mb-1">{school.name}</h5>
                                                    {school.state && <small className="text-muted">{school.state}</small>}
                                                </div>
                                                <div className="card-footer bg-primary text-white py-2" style={{ fontSize: '14px' }}>
                                                    Select
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isAuthenticated: getisAuthenticated(state),
    parentSchools: getParentSchools(state),
    user: getUserData(state),
});

const mapDispatchToProps = dispatch => ({
    setSchool: (school) => dispatch(setSchool(school)),
    setParentSchools: (schools) => dispatch(setParentSchools(schools)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(SelectSchool);
